import { render, staticRenderFns } from "./t-input-person-list.vue?vue&type=template&id=36b0455b&"
import script from "./t-input-person-list.vue?vue&type=script&lang=js&"
export * from "./t-input-person-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports